import { YuukyuuKanriService } from "@/service/YuukyuuKanriService";
import { ListSearchItem, KanriDaichouListData } from "@/types/YuukyuuKanri";
import { computed, reactive, Ref, ref } from "vue";
import dayjs from "dayjs";

/*
 * 有給休暇情報取得一覧
 */
export function useYuukyuuList() {
  let loading = ref(0);
  let isError = ref(false);
  // 検索条件に一致した有給休暇情報リスト
  let resDataList = ref<KanriDaichouListData[]>([]);

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  // 一覧取得
  const getList = async (searchItem: ListSearchItem) => {
    loading.value++;

    // API
    const service = new YuukyuuKanriService();
    const res = await service.getKanriDaichouInfoList(searchItem);
    if (res) {
      resDataList.value = res;
    }
    loading.value--;
    return res;
  };

  return {
    isLoading,
    isError,
    getList,
  };
}
